<template>
  <div class="best">
    <div class="hero">
      <div class="hero-body" style="padding: 10px;">
        <div class="container">
          <h1 class="title is-size-1">Top Scores</h1>
          <h1 class="subtitle">Solo Scorecards
            <span class="is-pulled-right is-size-5 has-text-right"><a v-on:click="showDateOptions()" class="dates" title="Show Date Range"><i class="fas fa-calendar"></i></a></span>
          </h1>    
          <div v-if="showDates">
            <div class="field is-horizontal" style="max-width: 600px;">
              <div class="field-body">
                <div class="field">
                  <div><p>Start</p></div>
                  <input class="input" type="date" v-model="startDate" style="width: 200px;"/> 
                </div>
                <div class="field">
                  <div><p>End</p></div>
                  <input class="input" type="date" v-model="endDate" style="width: 200px;"/>
                </div>
                <div class="field">
                  <button class="button is-primary" v-on:click="getBestScores('Solo');">Go!</button> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="box" v-show="showError">
        <article class="message is-danger">
          <div class="message-body">
              {{ errorMessage }}
          </div>
        </article>
      </div>

      <div v-show="bestScores.length === 0 && pleaseWait">
        <div class="has-text-centered" style="background-color: #241d1e;">
          <br/>
          <br/>
          <img :src="`${publicPath}img/axes2_please_wait_rotating.gif`"/>
          <p style="font-family: inherit; color: #ffdd57; font-size: 0.9em;">Please wait, loading data...</p>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
        </div>
      </div>

      <div class="box best_box" v-if="!pleaseWait">
        <div v-show="bestScores.length === 0">
          <p>No data available.</p>
        </div>
        <div v-show="bestScores.length !== 0">
          <div>
            <div class="box" style="background-color: #333; color: white;">
              <div class="columns is-mobile">
                <div class="column is-7">
                  <p class="is-size-4">Player</p>
                </div>
                <div class="column is-5">
                  <p class="is-size-6">Top Score, Bullseyes</p>
                </div>
              </div>
            </div>
            <div v-for="(card, index) in bestScores" :key="card.player.id">
              <div class="box best_outer_box">
                <div class="columns is-mobile">
                  <div class="column is-2">
                    <p class="is-size-4">
                      {{ (index+1) }}
                    </p>
                  </div>
                  <div class="column is-1" style="padding: 4px; padding-top: 12px;">
                    <span v-if="card.country != ''">
                      <country-flag v-bind:country="card.country" size="normal" :title="card.country" rounded/>
                    </span>
                  </div>
                  <div class="column is-4" style="padding: 4px;">
                    <p class="is-size-6" style="margin-left: 10px;">
                      {{ card.player }}
                    </p>
                  </div>
                  <div class="column is-3" style="padding: 4px;">
                    <p class="is-size-4">
                      <a v-on:click="showScorecardById(card.scorecard_id)" title="View Scorecard" style="color: #ffdd57; font-weight:bold;">{{ card.highest_score }}</a>
                    </p>
                  </div>
                  <div class="column is-2" style="padding: 4px;">
                    <p class="is-size-4">
                      {{ card.bullseyes }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br/>
      <br/>
    </div>
  </div>
</template>

<style scoped>
.best {
  background-color: #181313;
  min-height: 100vh;
  color: white;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
}
.hero {
  background-color: #2e7d32;
  color: white;
  margin-bottom: 20px;
}
.box {
  margin-top: 20px;
  margin-bottom: 20px;
  font-family: inherit;
  background-color: #242424;
  color: white;
  border: 1px solid #444;
}
.best_box {
  background-color: #1a1a1a; 
  padding-top: 10px; 
  padding-bottom: 10px;
  border: none;
}
.best_outer_box {
  background-color: #242424; 
  color: white;
  border: 1px solid #444;
}
.blink {
  font-family: inherit;
  color: #ffdd57;
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
a {
    color: #ffdd57;
    text-decoration: none;
    transition: color 0.2s;
}
a:hover {
    color: white;
}
</style>

<script>
import axios from "axios";
import moment from 'moment';

export default {
  name: 'best',
  components : {
  },
  computed: {
  },
  data () {
    return {
      debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
      publicPath: process.env.BASE_URL,
      bestScores: [],
      profiles: [],
      errorMessage: '',
      showError: false,
      pleaseWait: true,
      startDate: moment().startOf('month').format('YYYY-MM-DD'),
      endDate: moment().endOf('month').format('YYYY-MM-DD'),
      showDates: false
    }
  },
    methods:{
      showDateOptions: function() {
        this.showDates = !this.showDates;
      },
      showScorecardById: function(scorecard_id) {
        const url = this.$parent.getApiUrl(`scorecard/${scorecard_id}`);
        const token = this.$parent.getApiToken();

        axios.get(url,{
            headers: {
                authorization: token
            }
        })
        .then((response) => {
          this.$parent.showModal(response.data);
        }, (error) => {
          alert(error);
        });

      },
      getBestScores: function (gameType) {
        const url = this.$parent.getApiUrl(`best/${this.startDate}/${this.endDate}/${gameType}`);
        this.pleaseWait = true;
        this.bestScores = [];
        axios.get(url)
          .then((response) => {
            if (response.data.error != null) {
              this.errorMessage = response.data.error;
              this.showError = true;
              this.pleaseWait = false;
            } else {
              this.bestScores = response.data; 
              this.pleaseWait = false;
            }
          }, (error) => {
            this.errorMessage = error;
            this.showError = true;
            this.pleaseWait = false;
          });
      },
    },
    mounted(){
      setTimeout(() => {
        this.getBestScores("Solo");
      }, 1000);
    }
}
</script>